import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const yesItems = ['Sos mamá o cuidás a alguien y cada enfermedad se convierte en una emergencia', 'Te angustiás cuando tus hijos se despiertan con fiebre o tos a las 3am', 'Gastás $40.000–$60.000 por mes en la farmacia y ya no podés más', 'Abrís Google cuando se enferman y terminás más confundida que antes', "Vivís en departamento y creés que los remedios naturales son 'solo para los que tienen jardín'", 'Querés soluciones concretas, no teoría — qué hacer, en qué dosis, cuándo', 'Sabés que la farmacia te cobra el miedo, no el producto'];
const noItems = ['Buscás un reemplazo para tratamientos médicos serios o enfermedades crónicas', 'Querés magia instantánea sin hacer nada'];
export function IsForYouSection() {
  return <section className="py-16 bg-parchment" data-id="element-110">
      <div className="max-w-5xl mx-auto px-4" data-id="element-111">
        <ScrollReveal data-id="element-112">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-brown mb-12" data-id="element-113">
            El Botiquín Ancestral es para vos si...
          </h2>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-114">
          {/* YES column */}
          <ScrollReveal delay={100} data-id="element-115">
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-brown/5 h-full" data-id="element-116">
              <div className="flex items-center gap-2 mb-6" data-id="element-117">
                <CheckCircle2Icon className="w-7 h-7 text-forest" data-id="element-118" />
                <h3 className="font-bold text-xl text-forest" data-id="element-119">
                  Sí, es para vos si:
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-120">
                {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-121">
                    <CheckCircle2Icon className="w-5 h-5 text-forest shrink-0 mt-0.5" data-id="element-122" />
                    <span className="text-brown/80 leading-relaxed" data-id="element-123">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </ScrollReveal>

          {/* RIGHT column: NO + CTA */}
          <div className="flex flex-col gap-8" data-id="element-124">
            <ScrollReveal delay={200} data-id="element-125">
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-brown/5" data-id="element-126">
                <div className="flex items-center gap-2 mb-6" data-id="element-127">
                  <XCircleIcon className="w-7 h-7 text-red-500" data-id="element-128" />
                  <h3 className="font-bold text-xl text-red-500" data-id="element-129">
                    NO es para vos si:
                  </h3>
                </div>
                <ul className="space-y-4" data-id="element-130">
                  {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-131">
                      <XCircleIcon className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-132" />
                      <span className="text-brown/80 leading-relaxed" data-id="element-133">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300} data-id="element-134">
              <div className="bg-forest rounded-2xl p-6 md:p-8 text-center shadow-lg" data-id="element-135">
                <h3 className="font-serif text-xl md:text-2xl font-bold text-white mb-3" data-id="element-136">
                  ¿Te identificaste con alguno de los puntos de arriba?
                </h3>
                <p className="text-white/80 mb-6" data-id="element-137">
                  Entonces el Botiquín Ancestral fue diseñado exactamente para
                  vos.
                </p>
                <a href="#checkout" className="inline-block bg-white text-forest font-bold text-lg px-8 py-4 rounded-xl hover:bg-cream transition-colors shadow-md" data-id="element-138">
                  🌿 Quiero mi Botiquín — $17.990
                </a>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>;
}